import React, { useEffect } from 'react';
import { Box, Button, Paper, Stack } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useHistory } from 'react-router-dom';
import { Header } from '../../components/Header';
import { useAuth } from '../../hooks/Auth';
import { usePickup } from '../../hooks/Pickup';
import {
  Container,
  Content,
  Route,
  CollectRequesterTypeText,
  TitlePage
} from './styled';

const CollectType = () => {
  const { user, signOut } = useAuth();
  const { branchParameterizationId } = usePickup();

  const maxXS = useMediaQuery('(max-width:480px)');
  const maxSM = useMediaQuery('(max-width:768px)');
  const maxMD = useMediaQuery('(max-width:900px)');

  const history = useHistory();

  const handleClickSenderButton = () => {
    localStorage.setItem('@Braspress:requesterType', 'sender');
    history.push('/acesso-rapido/pedido-de-coleta/padrao');
  };

  const handleClickRecipientButton = () => {
    localStorage.setItem('@Braspress:requesterType', 'recipient');
    history.push('/acesso-rapido/pedido-de-coleta/padrao');
  };

  useEffect(() => {
    if (!branchParameterizationId) {
      history.push('/acesso-rapido/tipo-de-coleta');
    }
  }, []);

  return (
    <Container>
      {/* <Header /> */}
      <Content>
        <Box style={{ margin: '0 40px', paddingBottom: '40px' }}>
          {/* <Route>
            {!maxSM && (
              <>
                Home {'>'} Acesso Rápido {'>'} Pedido de Coleta
              </>
            )}

            {!!user && (
              <Stack
                direction="row"
                spacing={2}
                style={{
                  alignItems: 'center',
                  marginLeft: maxSM && 'auto'
                }}
              >
                <p>{user.name}</p>
                <Button
                  type="button"
                  variant="contained"
                  color="secondary"
                  data-testid="signOutButton"
                  onClick={signOut}
                  size="small"
                >
                  Sair
                </Button>
              </Stack>
            )}
          </Route> */}

          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: '128px'
            }}
          >
            <TitlePage>
              PEDIDO DE COLETA
              <hr />
              <span>Escolha uma das opções abaixo:</span>
            </TitlePage>

            <Paper
              elevation={3}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '64px',
                padding: '24px 40px'
              }}
            >
              <CollectRequesterTypeText>
                Defina o Solicitante
              </CollectRequesterTypeText>

              <Stack
                direction={maxXS ? 'column' : 'row'}
                spacing={maxXS ? 2 : 8}
                style={{ marginTop: 24 }}
              >
                <Button
                  type="button"
                  variant="contained"
                  data-testid="senderRequesterButton"
                  onClick={handleClickSenderButton}
                >
                  Remetente
                </Button>
                <Button
                  type="button"
                  variant="contained"
                  data-testid="recipientRequesterButton"
                  onClick={handleClickRecipientButton}
                >
                  Destinatário
                </Button>
              </Stack>
            </Paper>
          </Box>
        </Box>
      </Content>
    </Container>
  );
};

export default CollectType;
